<template>
	<AdditionalLayout title="Settings">
		<section class="settings section section--mini screen-start">
			<div class="settings__group">
				<button class="option settings__option">
					<i class="option__icon">
						<Icon name="language" />
					</i>
					<span class="option__name">Language</span>
					<span class="option__value">English</span>
				</button>
			</div>
			<div class="settings__group">
				<label class="option settings__option">
					<i class="option__icon">
						<Icon name="notifications" />
					</i>
					<span class="option__name">Push notifications</span>
					<span class="option__value">
						<Switch v-model="pushesEnabled" />
					</span>
				</label>
			</div>
			<div class="settings__group">
				<RouterLink class="option settings__option" to="/support">
					<i class="option__icon">
						<Icon name="support" />
					</i>
					<span class="option__name">Support</span>
				</RouterLink>
				<RouterLink class="option settings__option" to="/faq">
					<i class="option__icon">
						<Icon name="question" />
					</i>
					<span class="option__name">FAQ</span>
				</RouterLink>
				<button type="button" class="option settings__option" @click="openShareLink">
					<i class="option__icon"></i>
					<span class="option__name">Referral link</span>
				</button>
				<button class="option settings__option" type="button" @click="copySeed">
					<i class="option__icon"></i>
					<span class="option__name">Seed code</span>
				</button>
			</div>
			<div class="settings__group">
				<a href="#" target="_blank" class="option settings__option">
					<i class="option__icon">
						<Icon name="page" />
					</i>
					<span class="option__name">User Agreement</span>
				</a>
			</div>
		</section>
	</AdditionalLayout>
</template>
<script lang="ts" setup>
import "./SettingsView.scss";
import AdditionalLayout from "@/layouts/AdditionalLayout/AdditionalLayout.vue";
import Switch from "@/components/Switch/Switch.vue";
import Icon from "@/components/Icon/Icon.vue";
import {ref, watch} from "vue";
import {useUserStore} from "@/stores/userStore";
import {useAlertsStore} from "@/stores/alertsStore";
import {useApiStore} from "@/stores/apiStore";
import TelegramWebApp from "@/telegram/TelegramWebApp";
import {storeToRefs} from "pinia";
import copy from "copy-to-clipboard";

let userStore = useUserStore();
let alertsStore = useAlertsStore();
let {api} = useApiStore();

let {me} = storeToRefs(userStore);

let pushesEnabled = ref<boolean>(me.value!.is_pushes_enabled);

watch(pushesEnabled, async () => {

	await api.changeSettings({
		is_pushes_enabled: !!pushesEnabled.value,
	})

	me.value!.is_pushes_enabled = !!pushesEnabled.value

});

function openShareLink(){

	let text = 'Привет!';
	let inviteLink = 'https://t.me/sdlksakdaskldlkasbot?start=' + me.value!.chat;

	TelegramWebApp.app!.openTelegramLink('https://t.me/share/url?url=' + encodeURIComponent(inviteLink) + '&text=' + encodeURIComponent(text));

}

function copySeed(){

	copy(me.value!.seed);

	alertsStore.pushSuccess('Was copied to clipboard!');

}

</script>